/**
 * Kereső segédfüggvények (vans.hu)
 * - Rövid (11 karakteres) Vans cikkszám kiegészítése: VN000D3HY28 -> (VN000D3HY28 OR VN000D3HY281)
 * - Legutóbbi keresések mentése és megjelenítése (csak a látogató böngészőjében)
 */
(function () {
  if (window.KeresoSegito) return;

  var KULCS = 'vans_kereso_legutobbi';
  var MAX_DB = 6;

  // Készleten lévő termékek cikkszámai a részleges cikkszám-kereséshez (pl. d3hy28 -> VN000D3HY281)
  var KOD_KULCS = 'vans_kereso_cikkszamok_v3';
  var KOD_ERVENY = 30 * 60 * 1000;
  var KOD_MAX = 3;
  var kodok = null;
  var kodBetoltes = null;

  function kodokBetolt() {
    if (kodok || kodBetoltes) return kodBetoltes;
    try {
      var tarolt = JSON.parse(sessionStorage.getItem(KOD_KULCS) || 'null');
      if (tarolt && tarolt.t && Date.now() - tarolt.t < KOD_ERVENY && Array.isArray(tarolt.k)) {
        kodok = tarolt.k;
        return null;
      }
    } catch (e) {}
    var gyoker = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var alap = gyoker + 'collections/all?view=cikkszamok&filter.v.availability=1&page=';
    function oldal(n) {
      return fetch(alap + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var i = t.indexOf('|');
          if (i === -1) return { oldalak: 0, kodok: [] };
          return {
            oldalak: parseInt(t.slice(0, i), 10) || 1,
            kodok: t.slice(i + 1).trim().split(/\s+/).filter(function (k) { return /^[0-9A-Za-z]{4,20}:[0-9A-Za-z]{0,20}$/.test(k); })
          };
        });
    }
    kodBetoltes = oldal(1)
      .then(function (elso) {
        var tovabbi = [];
        for (var n = 2; n <= Math.min(elso.oldalak, 20); n++) tovabbi.push(oldal(n));
        return Promise.all(tovabbi).then(function (res) {
          var osszes = elso.kodok;
          res.forEach(function (r) { osszes = osszes.concat(r.kodok); });
          return osszes;
        });
      })
      .then(function (lista) {
        var egyedi = [];
        var latott = {};
        lista.forEach(function (k) {
          var u = k.toUpperCase();
          if (!latott[u]) { latott[u] = 1; egyedi.push(u); }
        });
        kodok = egyedi;
        try { sessionStorage.setItem(KOD_KULCS, JSON.stringify({ t: Date.now(), k: kodok })); } catch (e) {}
        frissitAktivKeresest();
        return kodok;
      })
      .catch(function () { kodBetoltes = null; });
    return kodBetoltes;
  }

  // Ha a betöltés alatt már cikkszám-részlet van a mezőben, frissítjük a találatokat
  function frissitAktivKeresest() {
    var el = document.activeElement;
    if (!el || el.name !== 'q' || !el.value) return;
    if (reszlegesKod(el.value.trim())) el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function reszlegesKod(t) {
    return /^[0-9A-Za-z]{4,20}$/.test(t) && /\d/.test(t) && /[A-Za-z]/.test(t);
  }

  // A részletből a teljes cikkszám(ok)ra bővítünk. Ha minden találat SKU-ja ugyanazzal a
  // kezdettel indul (a beírt részlet végéig), előtag-keresést használunk (a Shopify az utolsó
  // szót előtagként keresi), így minden készleten lévő találat megjön. Egyébként legfeljebb
  // KOD_MAX teljes cikkszámot adunk át.
  function kodBovit(t) {
    if (!kodok || !reszlegesKod(t)) return null;
    var u = t.toUpperCase();
    var talalat = [];
    var elotagok = {};
    var elotagDb = 0;
    for (var i = 0; i < kodok.length; i++) {
      var resz = kodok[i].split(':');
      var kod = resz[0];
      var sku = resz[1] || '';
      if (kod === u || sku === u) return null;
      var hely = sku.indexOf(u);
      if (kod.indexOf(u) === -1 && hely === -1) continue;
      talalat.push(kod);
      var elotag = kod;
      if (hely !== -1) {
        elotag = sku.slice(0, hely + u.length);
      } else if (sku.length === kod.length + 1 && sku.slice(2) === kod.slice(1)) {
        // pl. VN000D5RY281 -> VFN000D5RY281 (a SKU-ban egy betűvel több van a 2. helyen)
        elotag = sku.slice(0, kod.indexOf(u) + u.length + 1);
      }
      if (!elotagok[elotag]) { elotagok[elotag] = 1; elotagDb++; }
    }
    if (!talalat.length) return null;
    if (elotagDb === 1) {
      var egyetlen = Object.keys(elotagok)[0];
      // A Shopify előtag-keresése csak rövidebb (max. 10 karakteres) kezdetekre megbízható
      if (egyetlen.length <= 10 && egyetlen !== talalat[0]) return '(' + t + ' OR ' + egyetlen + ')';
    }
    return '(' + t + ' OR ' + talalat.slice(0, KOD_MAX).join(' OR ') + ')';
  }

  function atalakit(q) {
    if (!q || typeof q !== 'string') return q;
    if (/\bOR\b/.test(q) || q.indexOf('(') !== -1) return q;
    return q
      .trim()
      .split(/\s+/)
      .map(function (t) {
        var bovitett = kodBovit(t);
        if (bovitett) return bovitett;
        if (/^[A-Za-z]{2}[0-9A-Za-z]{9}$/.test(t) && /\d/.test(t)) {
          return '(' + t + ' OR ' + t + '1)';
        }
        return t;
      })
      .join(' ');
  }

  // A cikkszámlista betöltése, amikor a látogató a keresőmezőbe lép
  document.addEventListener(
    'focusin',
    function (e) {
      var el = e.target;
      if (el && el.name === 'q' && el.tagName === 'INPUT') kodokBetolt();
    },
    true
  );

  function olvas() {
    try {
      var adat = JSON.parse(localStorage.getItem(KULCS) || '[]');
      return Array.isArray(adat) ? adat.filter(function (x) { return typeof x === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function ir(lista) {
    try {
      localStorage.setItem(KULCS, JSON.stringify(lista.slice(0, MAX_DB)));
    } catch (e) {}
  }

  function mentes(q) {
    if (!q || typeof q !== 'string') return;
    var tiszta = q.trim().replace(/\s+/g, ' ');
    if (tiszta.length < 2 || tiszta.length > 60) return;
    var lista = olvas().filter(function (x) { return x.toLowerCase() !== tiszta.toLowerCase(); });
    lista.unshift(tiszta);
    ir(lista);
  }

  function torles(q) {
    ir(olvas().filter(function (x) { return x !== q; }));
  }

  window.KeresoSegito = { atalakit: atalakit, mentes: mentes, olvas: olvas, torles: torles };

  // Keresőűrlapok beküldése (fejléc kereső, keresési oldal)
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!(f instanceof HTMLFormElement)) return;
      var action = f.getAttribute('action') || '';
      var ut = action.split('?')[0];
      if (!/\/search\/?$/.test(ut)) return;
      var input = f.querySelector('input[name="q"]');
      if (!input) return;
      mentes(input.value);
      var uj = atalakit(input.value);
      if (uj === input.value) return;
      e.preventDefault();
      var url = new URL(action, window.location.origin);
      new FormData(f).forEach(function (ertek, kulcs) {
        if (kulcs === 'q') url.searchParams.set('q', uj);
        else url.searchParams.append(kulcs, String(ertek));
      });
      window.location.href = url.toString();
    },
    true
  );

  // Legutóbbi keresések megjelenítése a kereső üres állapotában
  if (!customElements.get('kereso-legutobbi')) {
    customElements.define(
      'kereso-legutobbi',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.render();
          // A kereső üres állapotát a téma újrarajzolja (morph), ilyenkor a lista kiürülhet: újratöltjük.
          if (!this._figyelo) {
            this._figyelo = new MutationObserver(function () {
              if (self._rajzol) return;
              var db = olvas().length;
              var li = self.querySelectorAll('li').length;
              if (li !== db || (!db && self.childElementCount)) {
                Promise.resolve().then(function () { self.render(); });
              }
            });
            this._figyelo.observe(this, { childList: true, subtree: true });
          }
        }

        disconnectedCallback() {
          if (this._figyelo) {
            this._figyelo.disconnect();
            this._figyelo = null;
          }
        }

        render() {
          var lista = olvas();
          var self = this;
          this._rajzol = true;
          this.innerHTML = '';
          if (!lista.length) {
            this._rajzol = false;
            return;
          }
          var cim = document.createElement('h4');
          cim.className = 'predictive-search-results__title';
          cim.textContent = this.getAttribute('data-cim') || 'Legutóbbi kereséseid';
          this.appendChild(cim);
          var ul = document.createElement('ul');
          ul.className = 'kereso-javaslatok__lista kereso-javaslatok__lista--legutobbi list-unstyled';
          lista.forEach(function (q) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            var url = new URL(self.getAttribute('data-search-url') || '/search', window.location.origin);
            url.searchParams.set('q', atalakit(q));
            url.searchParams.set('type', 'product');
            url.searchParams.set('options[prefix]', 'last');
            a.href = url.toString();
            a.className = 'pills__pill predictive-search-results__pill';
            a.textContent = q;
            var gomb = document.createElement('button');
            gomb.type = 'button';
            gomb.className = 'kereso-javaslatok__torles';
            gomb.setAttribute('aria-label', 'Törlés: ' + q);
            gomb.innerHTML = '&times;';
            gomb.addEventListener('click', function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              torles(q);
              self.render();
            });
            li.appendChild(a);
            li.appendChild(gomb);
            ul.appendChild(li);
          });
          this.appendChild(ul);
          Promise.resolve().then(function () { self._rajzol = false; });
        }
      }
    );
  }
})();
